import _ from 'lodash';
import { SortingDirection } from '../models/sortingDirection.model';

export function sortBy<T>(
  collection: T[],
  orderBy: string,
  sortingDirection?: SortingDirection,
  defaultOrderBy?: string,
  defaultDirection?: SortingDirection
): T[] {
  if (sortingDirection) {
    return _.orderBy(collection, orderBy, toLodashDirection(sortingDirection));
  }
  if (defaultOrderBy && defaultDirection) {
    return _.orderBy(collection, defaultOrderBy, toLodashDirection(defaultDirection));
  }
  return collection;
}

function toLodashDirection(sortingDirection: SortingDirection): 'asc' | 'desc' {
  if (sortingDirection === SortingDirection.ASC) {
    return 'asc';
  }
  return 'desc';
}
